import {
  IAnalyticsEventMeasure,
  IAnalyticsEventMeasureProperties,
} from './types';
import {
  getMeasures,
  getUniqEventNamesFromMeasure,
  getUniqFieldNamesFromMeasure,
} from './utils';
import { IMeasureFieldsFragment } from '../../../apollo/graphqlSchema';
import { hasEventFilter } from '../event/utils';
import { UnreachableCaseError } from 'ts-essentials';
import { getCreator } from '../user/utils';

const measureType = {
  CompoundMeasure: 'compound',
  SimpleMeasure: 'simple',
} satisfies Record<IMeasureFieldsFragment['__typename'], string>;

const measureHasEventFilter = (measure: IMeasureFieldsFragment) => {
  if (measure.__typename === 'CompoundMeasure') {
    return measure.measures.some((m) => hasEventFilter(m.eventConditions));
  } else if (measure.__typename === 'SimpleMeasure') {
    return hasEventFilter(measure.eventConditions);
  } else {
    throw new UnreachableCaseError(measure);
  }
};

const getMeasureEventProperties = (
  measure: IMeasureFieldsFragment,
): IAnalyticsEventMeasureProperties => ({
  object_type: 'measure',
  schema_name: measure.schema.name,
  measure_type: measureType[measure.__typename],
  object_owner: measure.version ? getCreator(measure.version) : undefined,
  has_event_filter: measureHasEventFilter(measure),
  measures: getMeasures(measure),
  object_id: measure.id,
  object_name: measure.name,
  events: getUniqEventNamesFromMeasure(measure),
  fields: getUniqFieldNamesFromMeasure(measure),
});

export const measureSaved = (
  measure: IMeasureFieldsFragment,
): IAnalyticsEventMeasure => ({
  eventName: 'Measure Saved',
  ...getMeasureEventProperties(measure),
});
